<template>
        <div>
                <div v-for="(option, index) in options.values" class="radio-text-item" :key="index">
                        <input :disabled="options.viewMode" :checked="checkedItem(index)"
                               :id="id + '-radio-' + symbols[index]" :name="'radio-group-' + id" type="radio"
                               @click="handleClick(index)"><label :for="id + '-radio-' + symbols[index]"
                                                                  :data-letter="symbols[index]" v-html="option">
                </label></div>
        </div>
</template>

<script>

    export default {
        name: 'radio-list',
        components: {},
        props: {
            id: String,
            value: undefined,
            options: Object,
            viewMode: {type: Boolean, default: false}
        },
        data() {
            return {
                symbols: ['а', 'б', 'в', 'г', 'д', 'е'],
            }
        },
        methods: {
            handleClick(index) {
                this.$emit('input', index);
            },
            checkedItem(index) {
                return index === this.value
            }

        },
    }
</script>


<style scoped>

</style>
